export const toolSlug = (companyName: string, programName: string): string => {
  const raw = `${companyName ?? ""}-${programName ?? ""}`;
  return raw
    .toLowerCase()
    .normalize("NFKD")
    .replace(/[\u0300-\u036f]/g, "")
    .replace(/&/g, "and")
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/^-+|-+$/g, "");
};
